/*******************************************************
 * Copyright (C) 1996-2019 The Digital Embassy Pty Ltd admin@thedigitalembassy.com.au
 * These source files are proprietary, confidential and the Intellectual Property
 * of The Digital Embassy Pty Ltd Unauthorized copying, modifying and/or distributing
 * of source files, via any medium is strictly prohibited
 *******************************************************/

import $ from 'jquery'
import cssVars from 'css-vars-ponyfill';

const requireAll = requireContext => requireContext.keys().map( requireContext )

// Import component scripts
const components = requireAll( require.context( './components', true, /^.*\.js$/ ) )
const renders    = requireAll( require.context( './render'    , true, /^.*\.js$/ ) )

const initComponents = () => {
  // Run component scripts
  components.forEach( m => typeof m.default === 'function' && m.default() )
  renders.forEach( m => typeof m.default === 'function' && m.default() )
  // Apply CSS variables in older browsers
  cssVars( { include: '#your-chat-style-css,#your-chat-style-css-custom' } )
}

const main = () => {

  const bubbles = $( '.your-chat__bubble' ),
        panels  = $( '.your-chat__panel' )

  if ( bubbles.length || panels.length ) {

    let total   = bubbles.length + panels.length,
        counter = 0

    bubbles.each( function() {
      const bubbleData = {
        action : 'your-chat/get-bubble-template',
        id     : $( this ).data( 'chat-id' ) || '',
      }

      $.post( ajaxurl, bubbleData )
       .done( response => {
         $( this ).replaceWith( response )
         if ( ++counter >= total )
           initComponents()
       } )
       .fail( ( xhr, status, error ) => {} )
    } )

    panels.each( function() {
      const panelData  = {
        action : 'your-chat/get-panel-template',
        id     : $( this ).data( 'chat-id' ) || '',
      }

      $.post( ajaxurl, panelData )
       .done( response => {
         $( this ).replaceWith( response )
         if ( ++counter >= total )
           initComponents()
       } )
       .fail( ( xhr, status, error ) => {} )
    } )

  }

}

// Side Effects
$( document ).ready( () => main() )
